import http from "@/http";
import {
  OBTER_NORMATIVOS,
  DEFINIR_NORMATIVOS,
  DEFINIR_FILTROS,
  DEFINIR_FILTROS_PESQUISA,
  OBTER_FILTROS_PESQUISA,
  LOCAL_STORAGE_ADD,
  DEFINIR_NORMATIVO,
  OBTER_NORMATIVO,
  CLEAR_NORMATIVOS,
  CONSULTAR_NORMATIVOS

} from "./../../tipo-acoes";
import { Estado, EstadoFiltro, EstadoFiltroPesquisa, EstadoLocalStorage } from "./../../index";
import INormativo from "@/interfaces/INormativo";
import INormativoFilter from "@/interfaces/INormativoFilter";
import { Module } from "vuex";
import IFiltro from "@/interfaces/IFiltro";
import ILocalStorage from "@/interfaces/ILocalStorage";
import IQueryBuilder from "@/interfaces/IQueryBuilder";
import IFiltroItem from "@/interfaces/IFiltroItem";

export interface EstadoNormativo {
  normativos: INormativo[];
  normativo: INormativo;
}
export interface EstadoFiltroFiltro {
  filtros: IFiltro[];
}
export interface EstadoFitroFiltroPesquisa {
  filtroPesquisa: INormativoFilter
}
export interface IEstadoLocalStorage {
  localStorage: Map<string, any>
}

export const localStorage: Module<IEstadoLocalStorage, EstadoLocalStorage> = {
  mutations: {
    [LOCAL_STORAGE_ADD](state, storage: ILocalStorage) {
      state.localStorage.set(storage.key, storage.value)
    },
  },
  actions: {
    [LOCAL_STORAGE_ADD]({ commit }, storage: ILocalStorage) {
      commit(LOCAL_STORAGE_ADD, storage);
    },
  },
  getters: {
    localStorageGet(state) {
      return state.localStorage.get('1');
    },
  },
};
export const filtroPesquisa: Module<EstadoFitroFiltroPesquisa, EstadoFiltroPesquisa> = {
  mutations: {
    [DEFINIR_FILTROS_PESQUISA](state, filtroPesquisa: INormativoFilter) {
      state.filtroPesquisa = filtroPesquisa;
    },
  },
  actions: {
    [DEFINIR_FILTROS_PESQUISA]({ commit }, filtroPesquisa: INormativoFilter) {
      commit(DEFINIR_FILTROS_PESQUISA, filtroPesquisa);
    },
  },
  getters: {
    fitroPesquisa(state) {
      return state.filtroPesquisa;
    },
  },
};

export const filtro: Module<EstadoFiltroFiltro, EstadoFiltro> = {
  mutations: {
    [DEFINIR_FILTROS](state, filtros: IFiltro[]) {
      state.filtros = filtros;
    },
  },
  actions: {
    [DEFINIR_FILTROS]({ commit }, filtros: IFiltro[]) {
      commit(DEFINIR_FILTROS, filtros);
    },
  },
  getters: {
    filtros(state) {
      return state.filtros;
    },
  },
};

export const normativo: Module<EstadoNormativo, Estado> = {
  mutations: {
    [DEFINIR_NORMATIVOS](state, normativos: INormativo[]) {
      normativos.forEach((normativo) => {
        normativo.filtroPattern = gerarPatternNormativo(normativo)
      })
      state.normativos = normativos;
    },
    [DEFINIR_NORMATIVO](state, normativo: INormativo) {
      state.normativo = normativo;
    },
  },

  actions: {
    async [OBTER_NORMATIVOS]({ commit }, builder: IQueryBuilder) {
      commit(DEFINIR_NORMATIVOS, []);
      if (builder) {
        builder.url += builder.value;
        await http
          .get(builder.url)
          .then((response) => commit(DEFINIR_NORMATIVOS, response.data));
      } else {
        commit(DEFINIR_NORMATIVOS, []);
      }
    },
    async [CONSULTAR_NORMATIVOS]({ commit }, builder: IQueryBuilder) {
      commit(DEFINIR_NORMATIVOS, []);      
      if (builder) {
        builder.url;
        await http
          .get(builder.url)
          .then((response) => commit(DEFINIR_NORMATIVOS, response.data));
      } else {
        commit(DEFINIR_NORMATIVOS, []);
      }
    },
    async [CLEAR_NORMATIVOS]({ commit }) {
      commit(DEFINIR_NORMATIVOS, []);   
    },
    async [OBTER_NORMATIVO]({ commit }, builder: IQueryBuilder) {
      commit(DEFINIR_NORMATIVO, {});
      
      if (builder) {
        builder.url += builder.value;
        await http
          .get(builder.url)
          .then((response) => commit(DEFINIR_NORMATIVO, response.data));
      } else {
        commit(DEFINIR_NORMATIVO, {});
      }
    },
  },
  getters: {
    normativos: (state) => {
      return state.normativos;
    },
    normativo: (state) => {
      return state.normativo;
    },
    filtrarNormativos: (state) => (f: IFiltroItem[]) => {      
      const groupedMap = f.reduce(
        (entryMap, e) =>
          entryMap.set(e.grupo, [...(entryMap.get(e.grupo) || []), e]),
        new Map()
      );
      let filterPattern: string[] = [];
      filterPattern = gerarPatternFiltros(groupedMap);
      const normativos:INormativo[] = state.normativos;
      if (f && f.length > 0) {        
        const normaFilter = normativos.filter((normativo) => {
          let isMatch = false
          if (normativo && normativo.filtroPattern) {
            normativo.filtroPattern.forEach((norm) => {
              if (filterPattern.includes(norm)) {
                isMatch = true;
                return
              }
            });
          }
          return (
            isMatch
          );
        });       
        return normaFilter
      }     
      return normativos;
    },
  },
};
function gerarPatternNormativo(normativo: INormativo) {
  const resultado: string[] = [];
  if (normativo && normativo.dataDocumento) {
    const data = normativo.dataDocumento.split('/')
    const listFiltrosDeclarados = [normativo.codigoNorma ?? '', normativo.dscSituacao ?? '', normativo.dataDocumento, data[0]]

    listFiltrosDeclarados.forEach((element) => {
      if (element) {
        if (listFiltrosDeclarados) {
          const parcial = combineNormativos(element, listFiltrosDeclarados)
          parcial.forEach((p) => {
            if (p && !resultado.includes(p)) {
              resultado.push(p.toLowerCase());
            }

          })

        }

      }
    })
  }
  return resultado;
}

function combineNormativos(atual: string, filtros: string[]) {
  const resultado: string[] = [];
  let combinado: string;
  resultado.push(atual);
  filtros.forEach((filtro) => {
    if (filtro != atual) {

      if (atual && !atual.includes(filtro)) {
        combinado = atual.concat(' ').concat(filtro);
        resultado.push(combinado);
      }
      const parcial = combineNormativos(combinado, filtros.slice(1));
      parcial.forEach((p) => {
        if (p && !resultado.includes(p)) {
          resultado.push(p);
        }
      })
    }
  });

  return resultado;
}

function gerarPatternFiltros(grupoFiltros: Map<string, IFiltroItem[]>) {
  const resultado: string[] = [];
  const sizeMap = grupoFiltros.size;

  for (const [key, value] of grupoFiltros) {
    value.forEach(element => {
      const parcial = combine(element, grupoFiltros);
      parcial.forEach((p) => {
        if (p) {
          let sizeString = 0;
          p = p.trim().toLowerCase();
          const split = p.split('@');
          if (split) {
            split.forEach((entry) => {
              if (entry && entry.trim()) {
                sizeString++;
              }
            })
          }
          if (sizeString == sizeMap && !resultado.includes(p)) {
            p = p.replaceAll('@', ' ').trim().toLowerCase();
            if (!resultado.includes(p)) {
              resultado.push(p);
            }
          }
        }
      })

    });
  }
  return resultado;
}

function combine(atual: IFiltroItem, grupoFiltros: Map<string, IFiltroItem[]>) {
  const resultado: string[] = [];
  const combinado: IFiltroItem = {   
    grupo:atual.grupo,
    valor: atual.valor,
    name: atual.name,
  };
  const sizeMap = grupoFiltros.size;
  if (sizeMap > 1) {
    for (const [key, filtros] of grupoFiltros) {
      filtros.forEach((filtro) => {
        if (filtro.valor != atual.valor) {
          if (atual && atual.grupo != filtro.grupo && !atual.valor.includes(filtro.valor)) {
            combinado.valor = atual.valor.concat('@').concat(filtro.valor).toLowerCase();
            resultado.push(combinado.valor);
          }
          const myMap = new Map(Array.from(grupoFiltros).slice(1));
          const parcial = combine(combinado, myMap);
          parcial.forEach((p) => {
            if (p && !resultado.includes(p)) {
              resultado.push(p.toLowerCase().concat('@'));
            }

          })
        }
      });
    }
  }
  else if (atual) {
    resultado.push(atual.valor.toLowerCase());
  }
  return resultado;
}
